export enum ERoute {
  Activation = '/activation',
  Login = '/login',
  RestorePasswordConfirmation = '/restore-password-confirmation',
  RestorePassword = '/restore-password',
  // Redesign
  // Super Admin
  CatalogList = '/catalog-list',
  CatalogListItem = '/catalog-list/:id',
  PropertiesSettings = '/properties-settings',
  BrandCatalogs = '/brand-catalogs',
  AccountList = '/account-list',
  ContractList = '/contract-list',
  CityList = '/city-list',
  // Super Admin: Mapper Admin (GARWIN-3)
  MapperAdmin = '/admin/mapper',
  MapperAdminTypes = '/admin/mapper/types',
  MapperAdminTypeDetail = '/admin/mapper/types/:id',
  MapperAdminMappings = '/admin/mapper/article-mappings',
  MapperAdminCatalog = '/admin/mapper/catalog',
  MapperAdminMatcher = '/admin/mapper/matcher',
  MapperAdminBrowser = '/admin/mapper/browser',
  // Admin
  Settings = '/settings',
  WorkspaceList = '/workspace-list',
  NewWorkspacePosition = '/new-workspace-position/:workspaceId',
  InventoryListForAccountAdmin = '/inventory-list/account_admin',
  // Seller Manager
  ActiveBasketList = '/active-basket-list',
  ActiveBasket = '/active-basket-list/:id',
  // Common
  Catalog = '/catalog',
  Basket = '/basket',
  Profile = '/profile',
  RequestList = '/request-list',
  Request = '/request/:id',
  Workspace = '/workspace-list/:id',
  InventoryList = '/inventory-list',
  InventoryListForUser = '/inventory-list/user',
  RfpList = '/rfp-list',
  RfpDraft = '/rfp/draft/:id',
  Rfp = '/rfp/:status/:id',
  SelfRegistration = '/self-registration',
  Registration = '/registration',
  Good = '/good/:goodId',
}
